"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownSearch = void 0;
var element_from_string_1 = require("../../utils/element-from-string");
var listener_1 = require("../../utils/event-listener/listener");
var event_trigger_1 = require("../../utils/event-trigger");
var DropdownSearch = function (target) {
    return /** @class */ (function (_super) {
        __extends(DropdownSearch, _super);
        function DropdownSearch() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        DropdownSearch.prototype.render = function () {
            var rendered = _super.prototype.render.call(this);
            var search = element_from_string_1.elementFromString('<span class="select2-search select2-search--dropdown">' +
                '<input class="select2-search__field" type="search" tabindex="-1"' +
                ' autocorrect="off" autocapitalize="none"' +
                ' spellcheck="false" role="searchbox" aria-autocomplete="list" />' +
                '</span>');
            this.searchContainer = search;
            this.search = search.querySelector('input');
            this.search.autocomplete = this.options.get('autocomplete');
            rendered.prepend(search);
            return rendered;
        };
        DropdownSearch.prototype.binding = function (select, container) {
            var _this = this;
            var resultsId = select.id + '-results';
            _super.prototype.binding.call(this, select, container);
            listener_1.createListener({
                elements: this.search,
                events: 'keydown',
                listeners: this.core.listeners,
                callback: function (event) {
                    _this.trigger('keypress', event);
                    _this._keyUpPrevented = event.defaultPrevented;
                }
            });
            var keyupListener = listener_1.createListener({
                elements: this.search,
                events: 'keyup',
                listeners: this.core.listeners,
                callback: function (event, eventName) {
                    _this.handleSearch(event);
                }
            });
            // Workaround for browsers which do not support the `input` event
            // This will prevent double-triggering of events for browsers which support
            // both the `keyup` and `input` events.
            listener_1.createListener({
                elements: this.search,
                events: 'input',
                listeners: this.core.listeners,
                callback: function (event) {
                    listener_1.destroyListener(keyupListener);
                    _this.handleSearch(event);
                }
            });
            select.on('open', function () {
                _this.search.setAttribute('tabindex', '0');
                _this.search.setAttribute('aria-controls', resultsId);
                setTimeout(function () { return event_trigger_1.eventTrigger(_this.search, 'focus'); });
            });
            select.on('close', function () {
                _this.search.setAttribute('tabindex', '-1');
                _this.search.removeAttribute('aria-controls');
                _this.search.removeAttribute('aria-activedescendant');
                _this.search.value = '';
                event_trigger_1.eventTrigger(_this.search, 'blur');
            });
            select.on('focus', function (event) {
                if (!select.isOpen()) {
                    event_trigger_1.eventTrigger(_this.search, 'focus');
                }
            });
            select.on('results:all', function (params) {
                if (params.query.term == null || params.query.term === '') {
                    var showSearch = _this.showSearch(params);
                    if (showSearch) {
                        _this.searchContainer.classList.remove('select2-search--hide');
                    }
                    else {
                        _this.searchContainer.classList.add('select2-search--hide');
                    }
                }
            });
            select.on('results:focus', function (params) {
                if (params.data._resultId) {
                    _this.search.setAttribute('aria-activedescendant', params.data._resultId);
                }
                else {
                    _this.search.removeAttribute('aria-activedescendant');
                }
            });
        };
        DropdownSearch.prototype.handleSearch = function (evt) {
            if (!this._keyUpPrevented) {
                var input = this.search.value;
                this.trigger('query', {
                    term: input
                });
            }
            this._keyUpPrevented = false;
        };
        DropdownSearch.prototype.showSearch = function (params) {
            return true;
        };
        return DropdownSearch;
    }(target));
};
exports.DropdownSearch = DropdownSearch;
//# sourceMappingURL=search.js.map